module.exports = __webpack_public_path__ + "static/media/arrow_left_mobile.683baea8.svg";